//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CFooter from "@/common/Footer"
export default {
  data() {
    return {
      money: '',
    }
  },
  components: {
    CFooter
  },
  mounted() {
    this.getInfo()
  },
  computed: {

  },
  methods: {
    getInfo() {
      let data = 'cmd=userinfo';
      this.$http.post('https://api.abeiyun.com/www/user.php', data).then(({data}) => {
        if(data.response == 200) {
          this.money = data.msg.money;
        } else {
          this.$router.push('/login')
        }
      })
    }

  }

}



// WEBPACK FOOTER //
// ./src/components/finance/catalog.vue